var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 2.8H2.8C2.32261 2.8 1.86477 2.98964 1.52721 3.32721C1.18964 3.66477 1 4.12261 1 4.6V15.4C1 15.8774 1.18964 16.3352 1.52721 16.6728C1.86477 17.0104 2.32261 17.2 2.8 17.2H9.1M12.7 2.8H13.6C14.0774 2.8 14.5352 2.98964 14.8728 3.32721C15.2104 3.66477 15.4 4.12261 15.4 4.6V5.5M15.4 14.5V15.4C15.4 15.8774 15.2104 16.3352 14.8728 16.6728C14.5352 17.0104 14.0774 17.2 13.6 17.2H12.7M15.4 9.1V10.9M8.2 1V19",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14,
    r: 5.5,
    fill: "#333333",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 13.25H15.75V11.75C15.75 11.5511 15.671 11.3603 15.5303 11.2197C15.3897 11.079 15.1989 11 15 11C14.8011 11 14.6103 11.079 14.4697 11.2197C14.329 11.3603 14.25 11.5511 14.25 11.75L14.2766 13.25H12.75C12.5511 13.25 12.3603 13.329 12.2197 13.4697C12.079 13.6103 12 13.8011 12 14C12 14.1989 12.079 14.3897 12.2197 14.5303C12.3603 14.671 12.5511 14.75 12.75 14.75L14.2766 14.7234L14.25 16.25C14.25 16.4489 14.329 16.6397 14.4697 16.7803C14.6103 16.921 14.8011 17 15 17C15.1989 17 15.3897 16.921 15.5303 16.7803C15.671 16.6397 15.75 16.4489 15.75 16.25V14.7234L17.25 14.75C17.4489 14.75 17.6397 14.671 17.7803 14.5303C17.921 14.3897 18 14.1989 18 14C18 13.8011 17.921 13.6103 17.7803 13.4697C17.6397 13.329 17.4489 13.25 17.25 13.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareAll);
export default __webpack_public_path__ + "static/media/CompareAll.36c49f8fe1479e0365f5838bd4bc8cf4.svg";
export { ForwardRef as ReactComponent };